import { useMemo } from "react";
import { useApp } from "../app";
import { MIN_SELECTABLE_ENTRIES } from "./avatarConstants";
import { useUserInfo } from "../user";
export const useAvatarImageModels = () => {
    const { avatarImageGeneration } = useApp();
    const { permissions } = useUserInfo();
    const { modelsToDisplay, modelsById } = useMemo(() => {
        const reducedModelsList = [];
        const byId = {};
        for (const model of avatarImageGeneration.models) {
            const isMissingPermission = Boolean(model.permission && !permissions?.includes(model.permission));
            if (isMissingPermission && model.hideUnauthorized) {
                continue;
            }
            const displayable = {
                ...model,
                isDisabled: isMissingPermission,
            };
            reducedModelsList.push(displayable);
            byId[model.id] = displayable;
        }
        return {
            modelsToDisplay: reducedModelsList,
            modelsById: byId,
        };
    }, [avatarImageGeneration.models, permissions]);
    const resolvedDefaultModelId = useMemo(() => {
        const configured = avatarImageGeneration.defaultModelId;
        const configuredEntry = configured ? modelsById[configured] : undefined;
        if (configuredEntry && !configuredEntry.isDisabled) {
            return configured;
        }
        const firstEnabled = modelsToDisplay.find((model) => !model.isDisabled);
        return firstEnabled?.id ?? "";
    }, [modelsToDisplay, modelsById, avatarImageGeneration.defaultModelId]);
    const defaultModel = useMemo(() => modelsById[resolvedDefaultModelId], [modelsById, resolvedDefaultModelId]);
    return {
        modelsToDisplay,
        modelsById,
        defaultModelId: avatarImageGeneration.defaultModelId,
        resolvedDefaultModelId,
        defaultModel,
        shouldShowSelector: modelsToDisplay.length >= MIN_SELECTABLE_ENTRIES,
    };
};
